<script>

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Socials from "../../sign_up/Socials.vue";

export default {
  components:{
    Loading,
    Socials
  },
  props: {
    activeStep: Number,
    totalSteps: Number
  },
  data(){
    return {
      isLoading: false,
      error: null,
      full_name: ''
    }
  },
  computed: {
    bookingProgress() {
      return this.activeStep * 100 / this.totalSteps
    }
  },
  mounted() {
    this.isLoading = true
    this.$axios.get('/v3/users/profile').then(response => {
      this.full_name = response.data.full_name
      this.isLoading = false
    })
    .catch(error => {
        this.isLoading = false
      })
    this.$refs.name.focus()
  },
  methods: {
    setGuesToken() {
      let token = localStorage.getItem("token", "");
  
      if (token === null || token === "") {
        axios
          .get(`${window.location.origin}/api_tokens/new.json`)
          .then((response) => {
            localStorage.setItem("guest_token", response.data.jwt);
          });
      }
      else {
        localStorage.setItem("guest_token", token);
      }
    },
    signInUrl(){
      return `${window.location.origin}/users/sign_in`
    },
    nextStep() {
      let params = {
        user: {
          full_name: this.full_name
        }
      }
      this.isLoading = true
      this.$axios.put('/v3/users/profile', params)
        .then(response => {
          this.$emit('updateStep', { next_step: 'fill_email' })
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
        })
    },
    back() {
      this.$emit('updateStep', {  next_step: 'fill_description' })
    },
  },
}
</script>

<template>
  <div class="new-booking__art-type new-booking__content">
    <div class="vld-parent">
      <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        color="#FF8141"
      ></loading>
    </div>

    <div class="complete-signup-header__title">
      What is your
      <span class='complete-signup-header__primary_title'>
        full name?
      </span>
    </div>

    <p class="mt-4 mb-4">
      Provide your name so the artist can reach out to you once the booking is confirmed
    </p>

    <div class="new-booking__content">
      <p class="mb-3">Enter your name</p>
      <div class="forms__item-100">
        <input
          v-model="full_name"
          type="text"
          :required="true"
          class="input order-capture-input border-0 mb-0"
          v-bind:class="{ 'error': error}"
          placeholder="John Smith"
          @input="full_name = full_name.replace(/[^a-zA-Z\s]/g, '')"
          ref="name">
        <span v-if="error" class="error-message">{{ error? error.toString() : null }}</span>
      </div>

      <p class="auth-form-content mb-3 text-start">or use the below options for faster booking </p>

      <socials :show="false" />

      <div class="auth-form-content text-start">
        Already a member? <a @click="setGuesToken()" :href="signInUrl()">Log in</a>
      </div>

      <div class="mt-5">
        <div class="back-next">
          <button
            class="settings-forms__btn btn secondary fluid"
            @click="back()">
            Back
          </button>
          <button
            class="settings-forms__btn btn primary fluid"
            :disabled="!full_name || full_name === ''"
            @click="nextStep()">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>
